import { useToggle } from "@able/react/dist/_hooks";
import ConfirmationDestructiveDialog from "@able/react/dist/ConfirmationDestructiveDialog";
export { ConfirmationDestructiveDialog, useToggle }
export const CURRENT_ABLE_VERSION = "able1";